import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';

type ReportsPageEntryPointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const reportsSatisfactionPageEntryPoint: EntryPoint<ReportsPageEntryPointComponent, {}> = {
	root: JSResourceForUserVisible<ReportsPageEntryPointComponent>(
		/* webpackChunkName: "async-csm-reports-satisfaction-entrypoint" */
		'./ReportsSatisfactionPage.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({}),
};
